<template>
  <div id="vy_footer">
    
    <div id="vy_copyright" class="container-fluid pc_only">
      <div class="row ">
        <div class="col-6">&copy;ボラ活エール All Rights Reserved.</div>
        <div class="col-3">
          <span v-on:click="condition()" style="cursor:pointer">利用規約
          </span>
        </div>
        <div class="col-3"><span v-on:click="policy()" style="cursor:pointer">プライバシーポリシー</span></div>
      </div>
    </div>

    <div id="vy_copyright" class="container-fluid sp_only">
    
      <div style="font-size: 0.9em;
        display: flex;
        align-items: center;
        justify-content: center;">
        <div class="row ">
          <span class="col-5"><span v-on:click="condition()" style="cursor:pointer"><u>利用規約</u></span></span>
          <span class="col-7"><span v-on:click="policy()" style="cursor:pointer"><u>プライバシーポリシー</u></span></span><br>
          <div class="col-12" style="margin-top: 10px;">&copy;ボラ活エール All Rights Reserved.</div>
        </div>
      </div>
    </div>
  </div>
<!--  <div>
  <hr>
  <span v-on:click="volukatsu_yell_towa" style="cursor:pointer">ボラ活エールとは&nbsp;&nbsp;&nbsp;&nbsp;</span>
  <span v-on:click="riyo_kiyaku" style="cursor:pointer">利用規約&nbsp;&nbsp;&nbsp;&nbsp;</span>
  <span v-on:click="kojin_joho_hogo_hoshin" style="cursor:pointer">個人情報保護方針&nbsp;&nbsp;&nbsp;&nbsp;</span><br/>
  <span v-on:click="privacy_policy" style="cursor:pointer">プライバシーポリシー&nbsp;&nbsp;&nbsp;&nbsp;</span>
  <span v-on:click="faq" style="cursor:pointer">よくある質問&nbsp;&nbsp;&nbsp;&nbsp;</span>
  <span v-on:click="toiawase" style="cursor:pointer">お問合せ&nbsp;&nbsp;&nbsp;&nbsp;</span>
  </div>
  <div id="by_copyright" class="container-fluid" style="margin-top:20px">
    <div class="row">
      <div class="col-12">&copy;ボラ活エール  All Rights Reserved.</div>
    </div>
  </div> -->
</template>

<script setup>
/* eslint-disable */
import { useRouter } from 'vue-router'
const router = useRouter()

//------------------------------ リンク --------------------------------
const volukatsu_yell_towa = function() { router.push('/Ippan/volukatsu_yell_towa') }
const condition = function() { router.push('/Condition') }
const kojin_joho_hogo_hoshin = function() { router.push('/Ippan/kojin_joho_hogo_hoshin') }
const policy = function() { router.push('/Policy') }
const faq = function() { router.push('/Ippan/faq') }
const toiawase = function() { router.push('/Ippan/toiawase') }
</script>

<style scoped>

@media screen and (min-width: 971px) {
/* PC */
  .footer_pc_only{
    display: block
  }

  .footer_sp_only{
    display: none
    
  }
}

@media screen and (max-width: 970px) {
/* スマホ */
  .footer_pc_only{
    display: none
  }

  .footer_sp_only{
    display: block
    
  }
}
</style>
